import { Card, Col, Row, Button, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "./dashboard.scss";
import token from "../../assets/logo/token.png";
import brainaLiveLogo from "../../assets/logo/wallet.png";
import {
  DownloadOutlined,
  UploadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import dashboardService from "../../services/dashboardService";
import { ThemeContext } from "../../context/themeProvider";

const ROOT = `dashboard_module`;

export default function TotalRewards(props) {
  const { cardBackgroundColor } = props;
  const [earnings, setEarnings] = useState();
  const { setLoading } = useContext(ThemeContext);

  useEffect(() => {
    getDetailsFunc();
  }, []);

  const getDetailsFunc = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getUserEarnings();
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message ||
            "Something went worng in getting user details"
        );
      } else {
        setEarnings(response?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return;
    }
  };
  console.log(earnings?.walletDetails);
  return (
    <Card
      style={{ backgroundColor: `${cardBackgroundColor}` }}
      className={`${ROOT}__card_ui`}
      title="My Account"
    >
      <Row
        gutter={[15, 0]}
        className="token pt-0 d-flex justify-content-between"
      >
        <Col className="d-flex">
          <Col>
            <div>
              <img src={brainaLiveLogo} />
            </div>
          </Col>
          <Col>
            <p>Points Earned</p>
            <h4>
              {earnings?.walletDetails?.point?.$numberDecimal}
              <span>Points</span>
            </h4>
          </Col>
        </Col>

        <Col className="d-flex">
          <Col>
            <div>
              <img src={token} />
            </div>
          </Col>
          <Col>
            <p>Token Balance</p>
            <h4>
              {earnings?.walletDetails?.referralTokens?.$numberDecimal}
              <span>BAAI</span>
            </h4>
          </Col>
        </Col>
      </Row>
      <Row gutter={[40, 0]} className="rewards mt-4">
        <Col lg={8} xs={24}>
          <p>Total Rewards Earned</p>
          {earnings ? (
            <h4>
              {earnings?.referralEarning[0]?.earning?.$numberDecimal
                ? earnings?.referralEarning[0]?.earning?.$numberDecimal
                : "0"}
              <span>BAAI</span>
            </h4>
          ) : (
            <h4>
              0 <span>BAAI</span>
            </h4>
          )}
        </Col>
        <Col lg={8} xs={24} className="br-r-l">
          <p>Total Withdrawals</p>
          <h4>
            0 <span>BAAI</span>
          </h4>
        </Col>
        <Col lg={8} xs={24}>
          <p>Total Deposits</p>
          <h4>
            0 <span>BAAI</span>
          </h4>
        </Col>
      </Row>

      <Row gutter={[20, 0]} className="rewards mt-4">
        <Col lg={12}>
          <Button size="large" disabled block icon={<DownloadOutlined />}>
            Deposit
          </Button>
        </Col>
        <Col lg={12}>
          <Button
            size="large"
            block
            icon={<UploadOutlined />}
            disabled
            className="withdraw-btn"
          >
            Withdraw
          </Button>
        </Col>
      </Row>
      <Row align="middle" className="mt-2 info">
        <Col style={{ display: "flex", alignItems: "center" }}>
          <InfoCircleOutlined style={{ marginRight: "5px" }} />{" "}
          <p> Tokens will be available for trading in Q4 of 2024</p>
        </Col>
      </Row>

      {/* {page} */}
    </Card>
  );
}
